import React from "react";
import { TFunction } from "i18next";
import { Tooltip } from "@mui/material";
import classnames from "classnames";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { SettingsIcon } from "@aureskonnect/react-ui";

import { AppDispatch } from "../../../../../../redux/store";
import { setIsConsultModalOpened } from "../../../../../../redux/slices/fidelitySlice";
import { CESAR_LOYALTY } from "@constants/index";
import { onKeyboardActivate } from "@helpers/a11y";

type Props = {
    row: FidelityRow;
    isFidelityArchived: boolean;
    isLoading: boolean;
    setSelectedRows: (rows: FidelityRow[]) => void;
    t: TFunction;
};

export default function SettingsIconButton({
    row,
    isFidelityArchived,
    isLoading,
    setSelectedRows,
    t,
}: Props) {
    const dispatch = useDispatch<AppDispatch>();
    const handleClick = () => {
        if (row.fidelityChoiceIndex === CESAR_LOYALTY) {
            toast.info(
                `${t(
                    "Please note, Softavera loyalty can only be modified by the franchise."
                )!}`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                }
            );
        }
        dispatch(setIsConsultModalOpened(true));
        setSelectedRows([row]);
    };

    return (
        <Tooltip title={isFidelityArchived ? "" : t("configure")}>
            <div
                data-testid={`fidelity-shops-settings-icon-${row.Id}`}
                role="button"
                tabIndex={isFidelityArchived || isLoading ? -1 : 0}
                aria-label={t("configure")}
                aria-disabled={isFidelityArchived || isLoading}
                onKeyDown={onKeyboardActivate(handleClick)}
            >
                <SettingsIcon
                    onClick={handleClick}
                    height={25}
                    width={25}
                    style={{ marginTop: "8px", paddingRight: "5px" }}
                    className={classnames("pointer__clz fed_icn_BTconsult", {
                        "not-allowed-icon__clz":
                            isFidelityArchived || isLoading,
                    })}
                />
            </div>
        </Tooltip>
    );
}
